<template>
  <div>
    <div class="details-header">
      <div class="icon-bar">
        <img class="icon" src="../../../../assets/img/pic_qianyuenot.png">
        <h3>账单名称:<span>{{billDetails.billName}}</span></h3>
      </div>
      <div class="details-tag">
       <div class="status">
          <span class="title">账单状态</span>
          <span class="value status_tag" :style="`--color:${BILL_STATUS_TEXT_COLOR[billDetails.billStatus]}`">{{BILL_STATUS_TEXT[billDetails.billStatus]}}</span>
       </div>
       <div class="sum"> 
         <span class="title">账单总金额</span>
         <span class="value">￥{{billDetails.billMoneyTaxFormat}}</span>
       </div>
      </div>
      <div class="affirmBill">
        <span class="affirmTips"><a-icon class="circle" type="exclamation-circle" />账单金额若有疑议，请联系相关业务员核实</span>
      </div>
      <a-descriptions  bordered class="descriptions">
        <a-descriptions-item v-for="item in descColumns" :key="item.prop" :label="item.label">
         <span v-if="item.prop==='invoiceStatus'">{{receivableInvoiceStatusTxt[billDetails[item.prop]]||'--'}}</span>
         <span v-else-if="item.prop==='createTime'">{{tranTime(billDetails[item.prop])||'--'}}</span>
         <span v-else>{{billDetails[item.prop]||'--'}}</span>
        </a-descriptions-item>
      </a-descriptions>
        <div v-if="billDetails.billStatus === BILL_STATUS.BILL_RECONCILIATION"  class="active"> 
          <a-button 
          type="primary"
          class="action-btn"
          @click="handleConfirmBill(billDetails)">
            确认账单
          </a-button>
          <a-button 
          type="primary"
          class="action-btn"
          @click="handleBackBill(billDetails)">
            退回账单
          </a-button>
      </div>
    </div>
     <div class="details-content">
      <a-tabs v-model="active" @change="handleActive">
        <a-tab-pane v-for="item in tabConfigOption" :key="item.value" :tab="item.label" />
      </a-tabs>
        <pro-search
        v-if="active==='billDetail'"
        :fileds="detailsSearchFiled"
        :form="form"
        @search="handleSearch"
        @reset="handleReset"
        />
       <a-table
        :loading="tableLoading"
        :columns="tableType[active]"
        :data-source="detailsOrderData"
        row-key="orderCode"
        size="middle"
        :scroll="{ x: 'calc(700px + 50%)'}"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="refCode" slot-scope="text,row">
          <span class="details">
             <a v-if="filterOrder(text)" @click="checkDetail(row)">{{text}}</a>
             <span v-else class="twoOrder">{{text}}</span>
          </span>
        </template>
        <template slot="outCustomerName" slot-scope="text">
          <a-tooltip placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{text}}</span>
          </a-tooltip>
        </template>
        <template slot="lineName" slot-scope="text">
          <a-tooltip placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{text}}</span>
          </a-tooltip>
        </template>
        <template slot="startStationName" slot-scope="text">
          <a-tooltip  placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{text}}</span>
          </a-tooltip>
        </template>
        <template slot="startAddress" slot-scope="text">
          <a-tooltip  placement="top">
             <template slot="title">
               <span>{{text}}</span>
              </template>
              <span>{{text}}</span>
          </a-tooltip>
        </template>
        <template slot="fileUrl" slot-scope="text,row">
            <a v-if="row.ext&&row.ext.fileUrl&&row.ext.fileUrl.length" type="link" @click="handleView(row.ext.fileUrl)">查看</a>
        </template>
      </a-table>
     </div>
    <backBillDialog ref="backBillDialog" @refresh="handleRefresh" />
  </div>
</template>

<script>
import moment from 'moment'
import {billDetail,checkBill,getClearDetail, getInvoiceDetail, getAdjustDetail} from '@/api/bill.js'
import { moneyFormat,formatData} from '@/utils/util'
import ProSearch from '@/components/TableSearch/index.vue'
import {
  BILL_MONTH,
  receivableInvoiceStatusTxt,
  BILL_STATUS_TEXT,BILL_STATUS,
  detailsTableColumns,
  detailsSearchFiled,
  costBreakdownColumns,
  billAdjustmentEntryTableColumns,
  invoiceDetailTableColumns,
  BILL_STATUS_TEXT_COLOR
} from '../constant'
import backBillDialog from './backBillDialog.vue'

const tabConfig = {
  billDetail:'账目明细',
  billAdjustmentEntry:'账单调整记录',
  invoiceDetail:'开票明细'
}
  export default {
    name:'BillDetails',
    components:{
      backBillDialog,
      ProSearch,
    },
    data(){
      return {
        billDetails:{},
        detailsOrderData:[],
        detailsSearchFiled,
        costBreakdownColumns,
        BILL_STATUS_TEXT_COLOR,
        tableType:{
          billDetail:detailsTableColumns, // 账单明细
          billAdjustmentEntry:billAdjustmentEntryTableColumns,// 调整记录
          invoiceDetail:invoiceDetailTableColumns, // 发票明细
        },
        BILL_STATUS,
        costBreakdownData:[],
        checkRow:{},
        confirmLoading:false,
        costVisible:false,
        form:{},
        pagination: {
          current: 1,
          total: 0,
          pageSize:10,
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40', '50'],
          onShowSizeChange: (current, pageSize) => {
            this.pagination.pageSize = pageSize
          },
          showQuickJumper: true,
          showTotal: total => `共 ${total} 条`
      },
        BILL_MONTH,
        receivableInvoiceStatusTxt,
        BILL_STATUS_TEXT,
        descColumns:[
          {
            label:'账单批次号',
            prop:'billCode'
          },
          {
            label:'账单月份',
            prop:'accountMonth'
          },
          {
            label:'开票状态',
            prop:'invoiceStatus'
          },
          // {
          //   label:'开票主体',
          //   prop:'billingEntity'
          // },
          {
            label:'甲方开票主体',
            prop:'billingEntityA'
          },
          {
            label:'乙方开票主体',
            prop:'billingEntityB'
          },
          {
            label:'创建时间',
            prop:'createTime'
          },
        ],
        active:'billDetail',
        tableLoading: false,
      }
    },
    computed:{
      tranTime(){
        return (time)=>moment(time).format('YYYY-MM-DD HH:mm:ss'  )
      },
      conductLength(){
        return (text)=>{
         if(text){
           return text.length>20?`${text.substring(0,19)}...`:text
         }
         return text
        }
      },
      filterOrder(){
        return (text)=> {
          if(text){
            return text.indexOf('U')===0
          }
          return false
        };
      },
      tabConfigOption(){
         return formatData(tabConfig)
      },
    },
   async created(){
      await this.getDetails();
      this.fetchData();
    },
    methods:{
      async getDetails(){
        const {billId,billCode} = this.$route.query;
        const res = await billDetail({billId,billCode})
        this.billDetails = {...res, billMoneyTaxFormat: moneyFormat(res.billMoneyTax)};
      },
      checkDetail(row){
        this.$router.push({
        path: `/order/detail`,
        query: {
          odrNo: row.masterOrderCode
        },
      })
      },
      handleSearch(form){
        this.pagination.current=1
        this.form={
          ...form
        }
        this.fetchData()
      },
      handleCancel(){
        this.costVisible=false
      },
      handleReset(){
        this.pagination = {
        ...this.pagination,
        current: 1
        }
        this.form={}
        this.fetchData()
      },
      async getClearDetail(){
        // 清分明细
        const params = {
          size: this.pagination.pageSize,
          page: this.pagination.current
        }
        const {refCode,...restParams} = this.form;
        const data = {
          ...params,
          billCode: this.billDetails.billCode, 
          pricingSources:['NEGOTIATION_PRICING','NONE_OPERATING_PRICING','RULE_PRICING','BUYOUT_PRICE','EXPENSE_ENTRY'],
          ...restParams,
          refCode:refCode?[refCode]:undefined
        };
        const res = await getClearDetail(data)
        this.detailsOrderData=res.records.map(item=>{
          return {...item,costValue: moneyFormat(item.costValue)}
        })
        this.pagination.total = res.total
      },
      async getAdjustDetail(){
        const params = {
          size: this.pagination.pageSize,
          page: this.pagination.current
        }
        const data = {
          ...params,
          billCode: this.billDetails.billCode, 
          type: "BIZ_ADJUST"
        }
        const res =await getAdjustDetail(data);
        console.log(res,'res');
        this.detailsOrderData=res.records.map(item=>{
          return {...item, moneyTaxFormat: moneyFormat(item.moneyTax)}
        })
        this.pagination.total = res.total
      },
      async getInvoiceDetail(){
        const data = {
          billCodes: [this.billDetails.billCode],
          scene:'PAYABLE'
        }
        const res =await getInvoiceDetail(data);
        const bill = res.bills[0]
        if(bill) {
          const {invoices} = bill;
          invoices.forEach(item=>{
            item.payQuota = moneyFormat(item.payQuota)
            item.taxQuota = moneyFormat(item.taxQuota)
            item.usePayableTaxQuota = moneyFormat(item.usePayableTaxQuota)
          })
          this.detailsOrderData=invoices||[]
          this.pagination.total = invoices.length
        }else{
          this.detailsOrderData=[]
          this.pagination.total =0
        }
      },
      async fetchData(){
        const requestType = {
          billDetail:this.getClearDetail, // 账单明细
          billAdjustmentEntry:this.getAdjustDetail,// 调整记录
          invoiceDetail:this.getInvoiceDetail, // 发票明细
        }
        this.detailsOrderData = [];
        this.tableLoading = true;
        try {
          await requestType[this.active]()
          this.tableLoading = false;
        } catch (error) {
          this.tableLoading = false;
        }
      },
      handleTableChange(pagination) {
        this.pagination = {
          ...this.pagination,
          current: pagination.current
        }
        this.fetchData();
      },
      handleConfirmBill(row){
        // 确认账单
        this.$confirm({
          title: '确认账单',
          content: `账单金额${row.billMoneyTaxFormat||'-'}元`,
          okText:'确定',
          cancelText:'取消',
          onOk:async()=> {
            const {id,billCode} = row;
            await checkBill({moneyTax:row.billMoneyTax,billId:id,billCode,voucherDate:moment().format('YYYY-MM-DD')})
            this.$message.success('确认账单成功!')
            this.getDetails();
          },
        });
      },
    handleBackBill(row){
      // 退回账单
      this.$refs.backBillDialog.show(row)
    },
    handleRefresh(){
       this.getDetails();
    },
    handleActive(){
      this.handleReset()
    },
    handleView(fileList){
      this.$viewerApi({
          images: fileList
      })
    }
    }
  }
</script>

<style lang="less" scoped>
.details-header {
  border-radius: 6px;
  padding: 24px;
  margin-bottom: 20px;
  background: #fff;
  
  .icon-bar {
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    .icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
    }
    h3 {
      color: #171717;
      font-size: 18px;
      font-weight: 500;
      span{
        margin-left: 8px;
      }
    }
  }
  .details-tag {
    display: flex;
    margin-bottom: 32px;
    div{
      display: flex;
      flex-direction: column;
      padding: 0 40px;
    }
    .status {
      border-right: 1px solid #DCDEE0;
      .value {
        font-size: 18px;
        font-weight: 500;
        color: #171717;
      }
    }
    .sum .value {
      font-size: 18px;
      font-weight: 500;
      color: #ED4934; 
    }
  }
  .descriptions {
    margin-bottom: 24px;
  }
  .affirmBill {
    margin-bottom: 20px;
  }
  .affirmTips {
    // margin-left: 16px;
    font-size: 14px;
    color: #909399;
    .circle {
      margin-right: 6px;
    }
  }
}
.content_title {
  color: #171717;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  &::before{
    content: '';
    width: 4px;
    height: 16px;
    display: inline-block;
    background-color: #06B880;
    position: absolute;
    left: 24px;
    border-radius: 2px;
  }
}
.details-content {
  border-radius: 6px;
  padding: 24px;
  background: #fff;
}
.details {
  color: #06B880;
  a{
   text-decoration: underline;
  }
}
.twoOrder {
  color: rgba(0, 0, 0, 0.65);
  text-decoration: none;
}
.costBreakdown_Dialog {
  .sum {
    margin-bottom: 10px;
    font-size: 18px;
    .amount {
      color: #ED4934 ;
      margin-left: 6px;
    }
  }
}
.active{
  display: flex;
  align-items: center;
  flex-direction: row !important;
  .action-btn{
    margin-right: 8px;
  }
}
.status_tag{
  display: flex;
  align-items: center;
  &::before{
    content: '';
    width: 6px;
    height: 6px;
    background: var(--color);
    display: inline-block;
    margin-right: 8px;
    border-radius: 50%;
  }
}
</style>